import { currentEditionIdAtom } from "@/store/edition-id.store";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";

const EditionLayout = () => {
  const setEditionIdAtom = useSetAtom(currentEditionIdAtom);

  const { editionId = "" } = useParams();

  useEffect(() => {
    setEditionIdAtom(editionId);
  }, [editionId]);

  return <Outlet />;
};

export default EditionLayout;
